import type { ApiServiceConfig } from '@/types/api.config';

// API Service Configuration List
// Read configuration for each service from environment variables
export const apiServicesConfig: ApiServiceConfig[] = [
  {
    key: 'member',
    name: 'Member Service',
    baseURL: import.meta.env.PUBLIC_API_MEMBER_URL || '',
    useLocal: import.meta.env.PUBLIC_API_MEMBER_USE_LOCAL === 'true',
    localPort: Number(import.meta.env.PUBLIC_API_MEMBER_LOCAL_PORT),
    timeout: 30000,
    description: 'User membership related services',
  },
  {
    key: 'auth',
    name: 'Authentication Service',
    baseURL: import.meta.env.PUBLIC_API_AUTH_URL || '',
    useLocal: import.meta.env.PUBLIC_API_AUTH_USE_LOCAL === 'true',
    localPort: Number(import.meta.env.PUBLIC_API_AUTH_LOCAL_PORT),
    timeout: 30000,
    description: 'User authentication and authorization services',
  },
  {
    key: 'console',
    name: 'Console Service',
    baseURL: import.meta.env.PUBLIC_API_CONSOLE_URL || '',
    useLocal: import.meta.env.PUBLIC_API_CONSOLE_USE_LOCAL === 'true',
    localPort: Number(import.meta.env.PUBLIC_API_CONSOLE_LOCAL_PORT),
    timeout: 30000,
    description: 'Console management services',
  },
  {
    key: 'billing',
    name: 'Billing Service',
    baseURL: import.meta.env.PUBLIC_API_BILLING_URL || '',
    useLocal: import.meta.env.PUBLIC_API_BILLING_USE_LOCAL === 'true',
    localPort: Number(import.meta.env.PUBLIC_API_BILLING_LOCAL_PORT),
    timeout: 30000,
    description: 'Billing and management services',
  },
];

// Get configuration for a specific service
export const getApiServiceConfig = (
  key: string
): ApiServiceConfig | undefined => {
  return apiServicesConfig.find((service) => service.key === key);
};

// Get the base URL for a service
export const getServiceBaseURL = (key: string): string => {
  const config = getApiServiceConfig(key);
  if (!config) {
    throw new Error(`API service '${key}' not found`);
  }

  // If using local service, return local proxy address
  if (config.useLocal && config.localPort) {
    return `/api/${key}`;
  }

  return config.baseURL;
};
